import HeadingTertiatry from '../../atoms/headings/heading-tertiary/heading-tertiary.component';
import HeadingSecondary from '../../atoms/headings/heading-secondary/heading-secondary.component';

import './our-work-section.styles.scss';

const OurWorkSection = () => (
  <div className="ourWorkSection-container">
    <HeadingTertiatry text={'Our work'} />
    <HeadingSecondary text={'We are now busy with our first client...'} />
    <HeadingSecondary text={'Updates will follow :D'} />
  </div>
);

export default OurWorkSection;
